"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check

var _factory = require("./factory");

var _factory2 = _interopRequireDefault(_factory);

var _translator = require("../../translator");

var _translator2 = _interopRequireDefault(_translator);

var _refundExchangeAdapter = require("../refund-exchange-adapter");

var _selectPertinentPolicies = require("../select-pertinent-policies");

var _selectPertinentPolicies2 = _interopRequireDefault(_selectPertinentPolicies);

var _tagger = require("../tagger");

var _tagger2 = _interopRequireDefault(_tagger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RefundPolicies = function () {
  function RefundPolicies(_ref) {
    var phrases = _ref.phrases,
        locale = _ref.locale;

    _classCallCheck(this, RefundPolicies);

    this.translator = /** @type {Translator.Service} */new _translator2.default(phrases);
    this.locale = locale;
  }

  /**
   * @param {V2.Departure} departure
   * @param {V2.Options?} options
   */


  _createClass(RefundPolicies, [{
    key: "pertinent",
    value: function pertinent(departure, options) {
      var _this = this;

      var standardized_terms = (0, _refundExchangeAdapter.standardizeRefundsInput)(departure.terms);

      var _selectPertinentData = (0, _selectPertinentPolicies2.default)(standardized_terms),
          has_actionable_policies = _selectPertinentData.has_actionable_policies,
          pertinent_policies = _selectPertinentData.policies;

      var grouped_terms = (0, _refundExchangeAdapter.groupAdjacentPolicyTypes)(pertinent_policies);

      var formatted_terms = grouped_terms.map(function (data) {
        return (0, _factory2.default)(data, _this.locale);
      });

      var output = {
        is_refundable: has_actionable_policies,
        policies: this.translator.translateAll(formatted_terms)
      };

      return options && options.utm_tags ? (0, _tagger2.default)(options.utm_tags, output) : output;
    }
  }]);

  return RefundPolicies;
}();

exports.default = RefundPolicies;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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